export default __webpack_public_path__ + "static/media/CalledStrike.e3323e6d.svg";